import { useEffect } from 'react';
import { LoaderFunction, Outlet, useNavigate } from 'react-router-dom';
import { useIsPlatformUser, useLegalEntityRegions } from '../../hooks/useUser';
import { saveCallbackUrlFromLoader } from '../tasks-framework/utils';
import { useResolverFinishUrl } from '../tasks-framework/utils/hooks';

export const loader: LoaderFunction = ({ request, params }) => {
  saveCallbackUrlFromLoader({ request, params });

  return null;
};

export const Component = () => {
  const isPlatformUser = useIsPlatformUser();
  const regions = useLegalEntityRegions();
  const resolverFinishUrl = useResolverFinishUrl();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPlatformUser) {
      navigate('/home', { replace: true });
    } else if (regions.length === 0) {
      navigate(resolverFinishUrl, {
        replace: true,
        state: { fullWidthPlatformAppChrome: true },
      });
    }
  }, [navigate, isPlatformUser, resolverFinishUrl, regions.length]);

  return <Outlet />;
};
